import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useAdminAuth from './hooks/useAdminAuth';

const LoadingFallback = () => (
  <div className="flex items-center justify-center min-h-screen bg-white">
    <div className="animate-spin h-12 w-12 border-4 border-black border-t-transparent rounded-full"></div>
  </div>
);

const ProtectedAdminRoute = ({ children }) => {
  const { isAdmin, loading: adminAuthLoading, userId } = useAdminAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!adminAuthLoading) {
      if (!userId) {
        // useAdminAuth باید به /admin-login هدایت کند
      } else if (!isAdmin) {
        navigate('/admin-login', { replace: true });
      }
    }
  }, [isAdmin, adminAuthLoading, userId, navigate]);

  if (adminAuthLoading) {
    return <LoadingFallback />;
  }

  return isAdmin ? children : null;
};

export default ProtectedAdminRoute; 